import { KYMW9100Model } from '../kymw9100.model';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { LogSearchConditionModel } from '../vo/log-search-condition-model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * ログ検索画面　ログファイル出力サービス
 *
 * @export OutputLogFileService
 * @class OutputLogFileService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class OutputLogFileService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW9100Model;
  private successFunc: Function;
  private vo: LogSearchConditionModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof OutputLogFileService
   */
  private getBody(): PlessRequest {
    const parameters = {
      SearchTableCondition: this.vo.searchTableCondition
    };

    if (!PlessViewUtilsSub.isEmpty(this.vo.orderCode)) {
      parameters['OrderCode'] = this.vo.orderCode;
    }
    if (!PlessViewUtilsSub.isEmpty(this.vo.pcode)) {
      parameters['PCode'] = this.vo.pcode;
    }
    if (!PlessViewUtilsSub.isEmpty(this.vo.itemCode)) {
      parameters['ItemCode'] = this.vo.itemCode;
    }
    if (!PlessViewUtilsSub.isEmpty(this.vo.userID)) {
      parameters['UserID'] = this.vo.userID;
    }
    if (!PlessViewUtilsSub.isEmpty(this.vo.updateDateFrom)) {
      parameters['UpdateDateFrom'] = this.vo.updateDateFrom;
    }
    if (!PlessViewUtilsSub.isEmpty(this.vo.updateDateTo)) {
      parameters['UpdateDateTo'] = this.vo.updateDateTo;
    }
    if (!PlessViewUtilsSub.isEmpty(this.vo.sortColumnName)) {
      parameters['SortColumnName'] = this.vo.sortColumnName;
    }
    if (!PlessViewUtilsSub.isEmpty(this.vo.sortKind)) {
      parameters['SortKind'] = this.vo.sortKind;
    }

    return new PlessRequest({
      search: {
        OutputLogFile: {
          parameter: parameters,
          combination: PlessViewUtilsSub.isEmptyArray(this.vo.coopCodeList) ? [] :
            this.vo.coopCodeList.map(coopCode => {
              return {
                parameter: {
                  CoopCodeList: coopCode
                }
              }
            })
        }
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW9100Model} model
   * @param {any} this.vo
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof OutputLogFileService
   */
  execute(model: KYMW9100Model, vo: LogSearchConditionModel, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('outputLogFile', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetKYMW9100ListService
   */
  success(data: any) {
    if (data !== null) {
      this.successFunc(data);
    }
  }

  public fault(): void {
    super.fault();
  }

  public PlessErrorHandler(errList: any): void {
    super.plessErrorHandler(errList);
  }

  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }

}
